import React, { Component } from 'react';

import ReactDOM from 'react-dom';

import { connect } from 'react-redux';

import { ThunkDispatch } from 'redux-thunk';

import { RouteComponentProps, withRouter } from 'react-router-dom';



import { RootState } from '../../store';

import { ICollabSyncUi, IOrderRevisionLogEntry, IOrderState } from '../../store/order/orderStore';

import OrderApi from '../../store/order/OrderApi';

import Modal from '../layout/Modal/Modal';

import {

    clearActiveOrder,

    clearOrderActivity,

    collabActiveStateChanged,

    DEFAULT_COLLAB_SYNC_UI,

    endCollabMode,

    refreshOrderActivityIfNeeded,

    evaluateActiveOrderAvailability,

    getOpenOrders,

    remoteOrderUnavailable,

    setCollabSyncUi,

    syncOrderFromRemote,

    SyncOrderFromRemoteOptions,

} from '../../store/order/actions';

import { setAlert } from '../../store/alert/actions';

import {

    activateCollab,

    hasCollabPreference,

    IDLE_POLLS_BEFORE_SUSPEND,

    isCollabActive,

    isCollabSuspended,

    setCollabPreference,

    suspendCollab,

} from '../../utils/orderCollabStorage';

import { getPathAfterClosingOrder, readOrderIdFromPath } from '../../utils/orderRouteUtils';

import { getActorPrimary } from '../../utils/orderActivityUtils';

import { isHttpNotFound } from '../../utils/httpErrorUtils';

import {
    isOrderLockedFromPoll,
    parseOrderRevisionPollResult,
    readRevisionFromApiValue,
} from '../../store/order/orderRevision';

import {
    ORDER_REVISION_POLL_INTERVAL_MS,
    ORDER_REVISION_POLL_INTERVAL_SECONDS,
} from '../../config/backgroundSyncConfig';
import { setRevisionOrderMonitorActive } from '../../utils/openOrdersPollCoordinator';
import { recordBackgroundPoll } from '../../utils/backgroundSyncMetrics';

const POLL_INTERVAL_MS = ORDER_REVISION_POLL_INTERVAL_MS;

const POLL_INTERVAL_SECONDS = ORDER_REVISION_POLL_INTERVAL_SECONDS;

const OWN_WRITE_GRACE_MS = 4000;



type LockedReason = 'closed' | 'deleted' | 'unavailable';

interface State {

    showModal: boolean;

    showOrderUnavailableModal: boolean;

    unavailableReason: LockedReason | null;

    completedByEmail: string | null;

    baselineRevision: string | null;

    isSyncing: boolean;

    pollingOrderId: number | null;

}



interface DispatchProps {

    syncOrderFromRemote: (orderId: number, options?: SyncOrderFromRemoteOptions) => Promise<void>;

    clearActiveOrder: () => void;

    setCollabSyncUi: (ui: ICollabSyncUi) => void;

    collabActiveStateChanged: () => void;

    refreshOrderActivityIfNeeded: (orderId: number, remoteRevision: number | null) => Promise<void>;

    clearOrderActivity: () => void;

    remoteOrderUnavailable: (reason: LockedReason) => void;

    evaluateActiveOrderAvailability: () => void;

    evaluateActiveOrderAvailability: () => void;

    getOpenOrders: () => void;

    endCollabMode: () => void;

    setAlert: (message: string, type: string) => void;

}



interface StateProps {

    orderState: IOrderState;

    userEmail: string | null;

}



type Props = StateProps & DispatchProps & RouteComponentProps;



const getOrderIdFromOrder = (order: Props['orderState']['order']) =>

    order && order.orderheader ? order.orderheader.appOrderId : null;



export class OrderChangedBanner extends Component<Props, State> {

    pollTimer: number | null = null;

    pollInFlight = false;

    ownWriteGraceUntil = 0;

    nextCheckAt = 0;

    orderFetchGeneration = 0;

    idlePollStreak = 0;

    idlePollOrderId: number | null = null;

    forceLeaveInProgress = false;



    state: State = {

        showModal: false,

        showOrderUnavailableModal: false,

        unavailableReason: null,

        completedByEmail: null,

        baselineRevision: null,

        isSyncing: false,

        pollingOrderId: null,

    };



    componentDidMount() {

        if (!this.canRunCollab()) {
            return;
        }

        this.syncBaselineFromStore();

        this.syncRevisionPolling();

        this.syncCollabUiVisibility();

        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        window.setTimeout(this.pollRemoteOrder, 2000);

    }



    componentDidUpdate(prevProps: Props) {

        const couldRunCollab =
            !!prevProps.userEmail && !this.isAuthRoute(prevProps.location.pathname);

        if (couldRunCollab && !this.canRunCollab()) {
            this.teardownCollabUi();
        }

        const prevOrderId = getOrderIdFromOrder(prevProps.orderState.order);

        const currentOrderId = getOrderIdFromOrder(this.props.orderState.order);



        const prevCheckNonce =

            (prevProps.orderState.collabSyncUi && prevProps.orderState.collabSyncUi.checkNonce) || 0;

        const currentCheckNonce =

            (this.props.orderState.collabSyncUi && this.props.orderState.collabSyncUi.checkNonce) || 0;



        if (prevCheckNonce !== currentCheckNonce) {

            this.handleManualCollabCheck();

        }



        if (prevProps.orderState.endCollabNonce !== this.props.orderState.endCollabNonce) {

            this.handleStopCollaboration();

        }



        if (prevProps.orderState.leaveCollabOrderNonce !== this.props.orderState.leaveCollabOrderNonce) {

            this.handleLeaveOrder();

        }



        if (

            prevProps.orderState.remoteOrderUnavailableNonce !==

            this.props.orderState.remoteOrderUnavailableNonce &&

            this.props.orderState.orderRemotelyUnavailableReason

        ) {

            this.executeForceLeave(this.props.orderState.orderRemotelyUnavailableReason);

            return;

        }



        if (

            prevProps.orderState.orders !== this.props.orderState.orders &&

            !this.forceLeaveInProgress &&

            !this.state.showOrderUnavailableModal

        ) {

            this.props.evaluateActiveOrderAvailability();

        }



        const prevWriteResetNonce =

            (prevProps.orderState.collabSyncUi && prevProps.orderState.collabSyncUi.writeResetNonce) || 0;

        const currentWriteResetNonce =

            (this.props.orderState.collabSyncUi && this.props.orderState.collabSyncUi.writeResetNonce) || 0;



        if (prevWriteResetNonce !== currentWriteResetNonce) {

            this.resetCountdown();

        }



        if (prevProps.location.pathname !== this.props.location.pathname) {

            this.syncCollabUiVisibility();

            window.setTimeout(this.pollRemoteOrder, 1000);

        }



        if (prevOrderId !== currentOrderId) {

            this.resetIdlePollTracking(currentOrderId);

            this.setState({

                showModal: false,

                baselineRevision: null,

                pollingOrderId: null,

            }, () => {

                this.syncBaselineFromStore();

                this.syncCollabUiVisibility();

                this.pollRemoteOrder();

            });

            return;

        }



        const wasBusy = this.isOrderBusy(prevProps.orderState);

        const isBusy = this.isOrderBusy(this.props.orderState);

        const resolvedOrderId = this.resolveActiveOrderId();



        if (isBusy && !wasBusy) {

            this.ownWriteGraceUntil = Date.now() + OWN_WRITE_GRACE_MS;

        }



        if (wasBusy && !isBusy && resolvedOrderId) {

            this.ownWriteGraceUntil = Date.now() + OWN_WRITE_GRACE_MS;

            this.refreshBaseline(resolvedOrderId, true);

            return;

        }



        if (this.state.showModal || this.state.showOrderUnavailableModal || this.forceLeaveInProgress) {

            return;

        }



        if (!this.state.baselineRevision && resolvedOrderId && this.shouldMonitorOrder(this.props.orderState)) {

            this.refreshBaseline(resolvedOrderId);

        }

        this.syncRevisionPolling();

    }



    componentWillUnmount() {

        this.teardownCollabUi();

        document.removeEventListener('visibilitychange', this.handleVisibilityChange);

    }



    getLogin = () => this.props.userEmail;



    isUserLoggedIn = () => !!this.props.userEmail;



    isAuthRoute = (pathname: string = this.props.location.pathname) =>

        pathname === '/login' || pathname === '/forgot-password';



    canRunCollab = () => this.isUserLoggedIn() && !this.isAuthRoute();



    syncRevisionPolling = () => {

        if (!this.canRunCollab()) {

            setRevisionOrderMonitorActive(false);

            this.stopPolling();

            return;

        }

        const shouldMonitor = this.shouldMonitorOrder(this.props.orderState);

        setRevisionOrderMonitorActive(shouldMonitor);

        if (shouldMonitor) {

            this.startPolling();

        } else {

            this.stopPolling();

        }

    };



    notifyOpenOrdersListRefresh = () => {

        this.props.getOpenOrders();

    };



    teardownCollabUi = () => {

        setRevisionOrderMonitorActive(false);

        this.stopPolling();

        this.hideCollabSyncUi();

        this.props.setCollabSyncUi(DEFAULT_COLLAB_SYNC_UI);

        this.resetIdlePollTracking(null);

        this.orderFetchGeneration += 1;

        this.forceLeaveInProgress = false;

        this.setState({

            showModal: false,

            showOrderUnavailableModal: false,

            unavailableReason: null,

            completedByEmail: null,

            isSyncing: false,

            baselineRevision: null,

            pollingOrderId: null,

        });

    };



    resetIdlePollTracking = (orderId: number | null) => {

        this.idlePollStreak = 0;

        this.idlePollOrderId = orderId;

    };



    isOrderBusy = (orderState: IOrderState) =>

        orderState.isFetching ||

        orderState.isDashboardFetching ||

        orderState.orderIsPending;



    isActiveOrderRoute = () => {

        const path = this.props.location.pathname;

        return path.indexOf('/shop') === 0 ||

            path.indexOf('/dashboard') === 0 ||

            path.indexOf('/checkout') === 0 ||

            path.indexOf('/search') === 0 ||

            path.indexOf('/edit') === 0;

    };



    shouldMonitorOrder = (orderState: IOrderState) => {

        if (!this.canRunCollab()) {

            return false;

        }

        const order = orderState.order || orderState.dashboardOrder;



        if (order && order.orderheader) {

            const header = order.orderheader;

            if (header.orderIsFinal) {

                return false;

            }

            return header.orderState === 0;

        }



        return this.isActiveOrderRoute() && this.resolveActiveOrderId() !== null;

    };



    resolveActiveOrderId = () => {

        const orderState = this.props.orderState;

        const activeOrder = orderState.order || orderState.dashboardOrder;

        const fromOrder = getOrderIdFromOrder(activeOrder);

        if (fromOrder) {

            return fromOrder;

        }



        const fromPath = readOrderIdFromPath(this.props.location.pathname);

        if (fromPath) {

            return fromPath;

        }



        if (this.isActiveOrderRoute()) {

            const storedOrderId = localStorage.getItem('order');

            if (storedOrderId) {

                return +storedOrderId;

            }

        }



        return null;

    };



    isCollabModeActive = (orderId: number) =>

        isCollabActive(this.getLogin(), orderId);



    hasCollabOptIn = (orderId: number) =>

        hasCollabPreference(this.getLogin(), orderId);



    enableCollabPreference = (orderId: number) => {

        setCollabPreference(this.getLogin(), orderId, true);

        this.props.collabActiveStateChanged();

    };



    disableCollabPreference = (orderId: number) => {

        setCollabPreference(this.getLogin(), orderId, false);

        this.props.collabActiveStateChanged();

    };



    maybeRefreshActivityLog = (orderId: number, remoteRevision: string | null) => {

        const revision = readRevisionFromApiValue(remoteRevision);

        if (revision != null) {

            this.props.refreshOrderActivityIfNeeded(orderId, revision);

        }

    };



    suspendIdleCollab = (orderId: number) => {

        if (!suspendCollab(this.getLogin(), orderId)) {

            return;

        }



        this.resetIdlePollTracking(orderId);

        this.hideCollabSyncUi();

        this.props.collabActiveStateChanged();

    };



    resumeCollabIfOptedIn = (orderId: number) => {

        if (!isCollabSuspended(this.getLogin(), orderId)) {

            return false;

        }



        activateCollab(this.getLogin(), orderId);

        this.resetIdlePollTracking(orderId);

        this.syncCollabUiVisibility();

        this.props.collabActiveStateChanged();

        return true;

    };



    shouldShowCollabUi = () => {

        const orderId = this.resolveActiveOrderId();

        return !!orderId &&

            this.isCollabModeActive(orderId) &&

            this.shouldMonitorOrder(this.props.orderState) &&

            !document.hidden;

    };



    getCurrentCheckNonce = () =>

        (this.props.orderState.collabSyncUi && this.props.orderState.collabSyncUi.checkNonce) || 0;



    buildCollabUiPayload = (

        status: ICollabSyncUi['status'],

        nextCheckAt: number | null

    ): ICollabSyncUi => {

        const currentUi = this.props.orderState.collabSyncUi || DEFAULT_COLLAB_SYNC_UI;



        return {

            status,

            secondsRemaining: nextCheckAt

                ? Math.max(0, Math.ceil((nextCheckAt - Date.now()) / 1000))

                : POLL_INTERVAL_SECONDS,

            pollIntervalSeconds: POLL_INTERVAL_SECONDS,

            nextCheckAt,

            checkNonce: this.getCurrentCheckNonce(),

            lastUpdatedAt: currentUi.lastUpdatedAt,

            writeResetNonce: currentUi.writeResetNonce,

        };

    };



    hideCollabSyncUi = () => {

        this.props.setCollabSyncUi(DEFAULT_COLLAB_SYNC_UI);

    };



    dispatchCollabCountdown = () => {

        if (!this.shouldShowCollabUi() || this.state.isSyncing) {

            return;

        }



        this.props.setCollabSyncUi(

            this.buildCollabUiPayload('countdown', this.nextCheckAt)

        );

    };



    dispatchCollabSyncing = () => {

        this.props.setCollabSyncUi(

            this.buildCollabUiPayload('syncing', null)

        );

    };



    resetCountdown = () => {

        this.nextCheckAt = Date.now() + POLL_INTERVAL_MS;

        this.dispatchCollabCountdown();

    };



    syncCollabUiVisibility = () => {

        if (this.shouldShowCollabUi()) {

            if (!this.nextCheckAt || this.nextCheckAt <= Date.now()) {

                this.nextCheckAt = Date.now() + POLL_INTERVAL_MS;

            }

            if (!this.state.isSyncing) {

                this.dispatchCollabCountdown();

            }

            return;

        }



        this.hideCollabSyncUi();

    };



    handleManualCollabCheck = () => {

        if (!this.shouldShowCollabUi() || this.pollInFlight || this.state.isSyncing) {

            return;

        }



        this.pollRemoteOrder();

    };



    closeActiveOrderOnClient = (options?: { navigateToShop?: boolean }) => {

        const orderId = this.resolveActiveOrderId();



        if (orderId) {

            this.disableCollabPreference(orderId);

        }



        this.resetIdlePollTracking(null);

        this.hideCollabSyncUi();

        this.props.clearOrderActivity();



        localStorage.removeItem('order');

        this.props.clearActiveOrder();

        this.props.getOpenOrders();



        if (options && options.navigateToShop) {

            this.props.history.push('/shop');

            return;

        }



        const nextPath = getPathAfterClosingOrder(this.props.location.pathname);

        if (nextPath) {

            this.props.history.replace(nextPath);

        }

    };



    handleStopCollaboration = () => {

        this.setState({ showModal: false, isSyncing: false });

        this.closeActiveOrderOnClient();

    };



    isOnDashboard = () => this.props.location.pathname.indexOf('/dashboard') !== -1;



    refreshBaseline = async (orderId: number, hideModal?: boolean) => {

        try {

            const response = await OrderApi.getOrderRevision(orderId);

            const pollResult = parseOrderRevisionPollResult(response.data);



            if (

                pollResult.revision &&

                pollResult.appOrderId === orderId &&

                this.resolveActiveOrderId() === orderId

            ) {

                this.setState({

                    baselineRevision: pollResult.revision,

                    pollingOrderId: orderId,

                    showModal: hideModal ? false : this.state.showModal,

                });

            }

        } catch (e) {

            if (isHttpNotFound(e)) {

                this.executeForceLeave('deleted');

            }

            // Other baseline refresh errors retry on next poll / order update.

        }

    };



    isWithinOwnWriteGrace = () => Date.now() < this.ownWriteGraceUntil;



    syncBaselineFromStore = () => {

        const orderId = this.resolveActiveOrderId();

        if (orderId && this.shouldMonitorOrder(this.props.orderState)) {

            this.refreshBaseline(orderId);

        }

    };



    handleVisibilityChange = () => {

        if (document.hidden) {

            this.stopPolling();

            return;

        }

        this.syncRevisionPolling();

        this.syncCollabUiVisibility();

        this.pollRemoteOrder();

    };



    startPolling = () => {

        if (this.pollTimer !== null) {

            return;

        }



        this.pollTimer = window.setInterval(this.pollRemoteOrder, POLL_INTERVAL_MS);

    };



    stopPolling = () => {

        if (this.pollTimer !== null) {

            window.clearInterval(this.pollTimer);

            this.pollTimer = null;

        }

    };



    trackIdlePoll = (orderId: number) => {

        if (this.idlePollOrderId !== orderId) {

            this.resetIdlePollTracking(orderId);

        }



        this.idlePollStreak += 1;



        if (this.idlePollStreak >= IDLE_POLLS_BEFORE_SUSPEND) {

            this.suspendIdleCollab(orderId);

        }

    };



    runRemoteSync = async (orderId: number, showToast?: boolean) => {

        const fetchGeneration = ++this.orderFetchGeneration;

        this.setState({ isSyncing: true, showModal: false });

        if (this.isCollabModeActive(orderId)) {

            this.dispatchCollabSyncing();

        }

        try {

            await this.props.syncOrderFromRemote(orderId, {

                fromDashboard: this.isOnDashboard(),

                showToast,

                notifyAutoUpdate: !showToast && this.isCollabModeActive(orderId),

            });



            if (fetchGeneration !== this.orderFetchGeneration) {

                return;

            }



            await this.refreshBaseline(orderId, true);

            this.ownWriteGraceUntil = Date.now() + OWN_WRITE_GRACE_MS;

            this.resetIdlePollTracking(orderId);

        } finally {

            if (fetchGeneration !== this.orderFetchGeneration) {

                return;

            }



            this.setState({ isSyncing: false }, () => {

                if (this.isCollabModeActive(orderId)) {

                    this.resetCountdown();

                    this.syncCollabUiVisibility();

                }

            });

        }

    };



    pollRemoteOrder = async () => {

        if (document.hidden || this.pollInFlight || this.forceLeaveInProgress) {

            return;

        }



        if (!this.canRunCollab()) {

            return;

        }



        const orderState = this.props.orderState;

        if (!this.shouldMonitorOrder(orderState)) {

            return;

        }



        const orderId = this.resolveActiveOrderId();

        if (!orderId) {

            return;

        }



        const fetchGeneration = ++this.orderFetchGeneration;

        this.pollInFlight = true;

        let pollCompleted = false;



        try {

            const response = await OrderApi.getOrderRevision(orderId);

            recordBackgroundPoll('Order/GetOrderRevision');



            if (fetchGeneration !== this.orderFetchGeneration) {

                return;

            }



            const pollResult = parseOrderRevisionPollResult(response.data);



            if (!pollResult.revision || pollResult.appOrderId !== orderId) {

                return;

            }



            if (isOrderLockedFromPoll(pollResult.orderState)) {

                this.executeForceLeave('closed');

                return;

            }



            if (this.state.isSyncing) {

                pollCompleted = true;

                return;

            }



            pollCompleted = true;

            const remoteRevision = pollResult.revision;

            const baseline = this.state.baselineRevision;



            if (!baseline) {

                this.setState({

                    baselineRevision: remoteRevision,

                    pollingOrderId: orderId,

                });

                return;

            }



            if (remoteRevision !== baseline) {

                this.resetIdlePollTracking(orderId);

                this.notifyOpenOrdersListRefresh();



                if (this.isWithinOwnWriteGrace() || this.isOrderBusy(this.props.orderState)) {

                    this.setState({

                        baselineRevision: remoteRevision,

                        pollingOrderId: orderId,

                        showModal: false,

                    });

                    this.maybeRefreshActivityLog(orderId, remoteRevision);

                    return;

                }



                if (this.hasCollabOptIn(orderId)) {

                    this.resumeCollabIfOptedIn(orderId);

                    await this.runRemoteSync(orderId, false);

                    return;

                }



                this.maybeRefreshActivityLog(orderId, remoteRevision);

                this.setState({ showModal: true });

                return;

            }



            if (this.isCollabModeActive(orderId)) {

                this.trackIdlePoll(orderId);

            }

        } catch (e) {

            if (isHttpNotFound(e)) {

                this.executeForceLeave('deleted');

                return;

            }

            // Ignore transient poll errors; next interval retries.

        } finally {

            this.pollInFlight = false;

            if (pollCompleted && this.isCollabModeActive(orderId)) {

                this.resetCountdown();

            }

        }

    };



    findCheckoutActorInEntries = (entries: IOrderRevisionLogEntry[]): string | null => {

        if (!entries.length) {

            return null;

        }



        let latestSubmitted: IOrderRevisionLogEntry | null = null;



        entries.forEach((entry) => {

            if (entry.changeType !== 'ORDER_SUBMITTED') {

                return;

            }



            if (!latestSubmitted || entry.revisionNumber > latestSubmitted.revisionNumber) {

                latestSubmitted = entry;

            }

        });



        return latestSubmitted ? getActorPrimary(latestSubmitted) : null;

    };



    resolveCheckoutActorEmail = async (orderId: number): Promise<string | null> => {

        const fromActivity = this.findCheckoutActorInEntries(this.props.orderState.orderActivity.entries);

        if (fromActivity) {

            return fromActivity;

        }



        try {

            const response = await OrderApi.getOrderRevisionLog(orderId, undefined, 30);

            const entries: IOrderRevisionLogEntry[] = (response.data && response.data.entries) || [];

            return this.findCheckoutActorInEntries(entries);

        } catch {

            return null;

        }

    };



    runForceLeave = async (reason: LockedReason) => {

        const orderId = this.resolveActiveOrderId();

        let completedByEmail: string | null = null;



        if (reason === 'closed' && orderId) {

            completedByEmail = await this.resolveCheckoutActorEmail(orderId);

        }



        this.props.remoteOrderUnavailable(reason);

        this.stopPolling();



        if (orderId) {

            this.disableCollabPreference(orderId);

        }



        this.props.endCollabMode();

        this.resetIdlePollTracking(null);

        this.hideCollabSyncUi();

        this.props.clearOrderActivity();



        this.setState({

            showModal: false,

            isSyncing: false,

            showOrderUnavailableModal: true,

            unavailableReason: reason,

            completedByEmail,

        });

    };



    executeForceLeave = (reason: LockedReason) => {

        if (this.forceLeaveInProgress) {

            return;

        }



        this.forceLeaveInProgress = true;

        void this.runForceLeave(reason);

    };



    handleCloseUnavailableOrder = () => {

        this.closeActiveOrderOnClient();



        this.setState({

            showOrderUnavailableModal: false,

            unavailableReason: null,

            completedByEmail: null,

            showModal: false,

            isSyncing: false,

        });

        this.forceLeaveInProgress = false;

    };



    handleEnableCollaboration = () => {

        const orderId = this.resolveActiveOrderId();

        if (!orderId) {

            return;

        }



        this.enableCollabPreference(orderId);

        this.resetIdlePollTracking(orderId);

        this.resetCountdown();

        this.syncCollabUiVisibility();

        this.runRemoteSync(orderId, false);

    };



    handleLeaveOrder = () => {

        this.setState({ showModal: false });

        this.closeActiveOrderOnClient({ navigateToShop: true });

        this.forceLeaveInProgress = false;

    };



    handleContinueWithoutLiveUpdates = () => {

        const orderId = this.resolveActiveOrderId();

        this.setState({ showModal: false });

        if (orderId) {

            this.refreshBaseline(orderId, true);

        }

    };



    renderCollaborationModal = () => {

        return (

            <div className="order-changed-modal">

                <div className="order-changed-modal__body">

                    <h2 className="order-changed-modal__title">This order has changed</h2>

                    <p className="order-changed-modal__text">

                        A colleague has updated this order.

                        Do you want to follow new changes live while you continue?

                    </p>

                </div>



                <div className="order-changed-modal__footer">

                    <button

                        type="button"

                        className="btn order-changed-modal__btn--primary"

                        onClick={this.handleEnableCollaboration}

                        disabled={this.state.isSyncing}

                    >

                        {this.state.isSyncing ? 'Following live changes…' : 'Follow live changes'}

                    </button>

                    <button

                        type="button"

                        className="btn"

                        onClick={this.handleContinueWithoutLiveUpdates}

                        disabled={this.state.isSyncing}

                    >

                        Continue without live updates

                    </button>

                </div>

            </div>

        );

    };



    renderOrderUnavailableOverlay = () => {

        const orderId = this.resolveActiveOrderId();

        const orderLabel = orderId ? `B2B${orderId}` : 'This order';

        const reason = this.state.unavailableReason;

        const completedByEmail = this.state.completedByEmail;

        const isDeleted = reason === 'deleted';
        const isUnavailable = reason === 'unavailable';

        const title = isUnavailable
            ? 'Order unavailable'
            : isDeleted
                ? 'Order deleted'
                : 'Order completed';

        const message = isUnavailable ? (

            <>

                {orderLabel} is no longer available. Close the order to continue working where you left off.

            </>

        ) : isDeleted ? (

            <>

                {orderLabel} was deleted in another session. Close the order to continue working where you left off.

            </>

        ) : completedByEmail ? (

            <>

                <span className="order-unavailable-dialog__email">{completedByEmail}</span>

                {' has completed '}

                {orderLabel}

                . Close the order to continue working where you left off.

            </>

        ) : (

            <>

                {orderLabel} was completed in another session. Close the order to continue working where you left off.

            </>

        );



        return ReactDOM.createPortal(

            <div className="order-unavailable-overlay">

                <div className="order-unavailable-dialog">

                    <div className="order-unavailable-dialog__body">

                        <h2 className="order-unavailable-dialog__title">{title}</h2>

                        <p className="order-unavailable-dialog__text">{message}</p>

                    </div>

                    <div className="order-unavailable-dialog__footer">

                        <button

                            type="button"

                            className="btn order-unavailable-dialog__btn"

                            onClick={this.handleCloseUnavailableOrder}

                        >

                            Close order

                        </button>

                    </div>

                </div>

            </div>,

            document.getElementById('root') as HTMLElement

        );

    };



    render() {

        if (!this.canRunCollab()) {

            return null;

        }

        return (

            <>

                {this.state.showOrderUnavailableModal && this.renderOrderUnavailableOverlay()}



                {this.state.showModal && (

                    <Modal

                        children={this.renderCollaborationModal()}

                        size="sm"

                        hideClose={true}

                        hide={() => undefined}

                        isShowing={this.state.showModal}

                        hideHeader={true}

                        hideFooter={true}

                        bodyClasses="confirm-modal"

                    />

                )}

            </>

        );

    }

}



const mapStateToProps = (state: RootState): StateProps => ({

    orderState: state.order.order,

    userEmail: state.user.user.user && state.user.user.user.email

        ? state.user.user.user.email

        : null,

});



const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): DispatchProps => ({

    syncOrderFromRemote: async (orderId: number, options?: SyncOrderFromRemoteOptions) => {

        await dispatch(syncOrderFromRemote(orderId, options));

    },

    clearActiveOrder: () => {

        dispatch(clearActiveOrder());

    },

    setCollabSyncUi: (ui: ICollabSyncUi) => {

        dispatch(setCollabSyncUi(ui));

    },

    collabActiveStateChanged: () => {

        dispatch(collabActiveStateChanged());

    },

    refreshOrderActivityIfNeeded: async (orderId: number, remoteRevision: number | null) => {

        await dispatch(refreshOrderActivityIfNeeded(orderId, remoteRevision));

    },

    clearOrderActivity: () => {

        dispatch(clearOrderActivity());

    },

    remoteOrderUnavailable: (reason) => {

        dispatch(remoteOrderUnavailable(reason));

    },

    evaluateActiveOrderAvailability: () => {

        dispatch(evaluateActiveOrderAvailability());

    },

    getOpenOrders: () => {

        dispatch(getOpenOrders());

    },

    endCollabMode: () => {

        dispatch(endCollabMode());

    },

    setAlert: (message, type) => {

        dispatch(setAlert(message, type));

    },

});



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderChangedBanner));


